var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._g(
      {
        staticClass: "dialog-container",
        class: { "dialog-modal": _vm.isModal },
      },
      _vm.listeners
    ),
    [
      _c(
        "div",
        {
          ref: "dialog",
          staticClass: "dialog-component",
          class: _vm.getClasses(_vm.classes),
          style: _vm.computedStyles,
          on: {
            click: function ($event) {
              $event.stopPropagation()
            },
          },
        },
        [
          _vm.hasHeader
            ? _c(
                "div",
                {
                  ref: "dialogHeader",
                  staticClass: "dialog-component-header",
                  class: _vm.getClasses(_vm.header.classes),
                  style: _vm.header.styles,
                },
                [
                  _vm._t("header", function () {
                    return [
                      _c(
                        "div",
                        {
                          staticClass: "dialog-component-header-container",
                          class: {
                            "dialog-component-header-container-no-title":
                              !_vm.header.title,
                          },
                        },
                        [
                          _vm.header.title
                            ? _c("div", {
                                staticClass: "dialog-component-header-title",
                                domProps: {
                                  innerHTML: _vm._s(_vm.header.title),
                                },
                              })
                            : _vm._e(),
                          _vm.header.hasCloseButton
                            ? _c(
                                "IconComponent",
                                {
                                  staticClass: "dialog-component-close-icon",
                                  on: { click: _vm.onCloseClick },
                                },
                                [_vm._v("close")]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]
                  }),
                ],
                2
              )
            : _vm._e(),
          _c(
            "div",
            {
              ref: "dialogBody",
              staticClass: "dialog-component-body",
              class: _vm.getClasses(_vm.body.classes),
              style: _vm.bodyStyles,
            },
            [
              _vm._t("body", function () {
                return [_c("pre", [_vm._v(_vm._s(_vm.body.content))])]
              }),
            ],
            2
          ),
          _vm.hasFooter
            ? _c(
                "div",
                {
                  ref: "dialogFooter",
                  staticClass: "dialog-component-footer",
                  class: _vm.getClasses(_vm.footer.classes),
                  style: _vm.footer.styles,
                },
                [
                  _vm._t("footer", function () {
                    return [
                      _c(
                        "div",
                        { staticClass: "dialog-component-footer-buttons" },
                        _vm._l(_vm.footer.buttons, function (button) {
                          return _c(
                            "ButtonComponent",
                            _vm._b(
                              {
                                key: button.id,
                                staticClass: "dialog-component-footer-button",
                                on: {
                                  click: function ($event) {
                                    return _vm.onFooterButtonClick(
                                      button.id,
                                      $event
                                    )
                                  },
                                },
                              },
                              "ButtonComponent",
                              _vm.buttonBinding(button),
                              false
                            ),
                            [
                              button.icon
                                ? _c("IconComponent", [
                                    _vm._v(_vm._s(button.icon)),
                                  ])
                                : _vm._e(),
                              _c("span", {
                                domProps: { innerHTML: _vm._s(button.text) },
                              }),
                            ],
                            1
                          )
                        }),
                        1
                      ),
                    ]
                  }),
                ],
                2
              )
            : _vm._e(),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }